import React, { Fragment } from 'react';


function Head(props) {
    return (
        <Fragment>
            <head>
                <meta charSet="utf-8"></meta>
                <meta name="description" content="Portal da Transparência da Prefeitura Municipal de Macuco"></meta>
                <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
                <link rel="apple-touch-icon" sizes="57x57" href="/apple-icon-57x57.png"></link>
                <link rel="apple-touch-icon" sizes="60x60" href="/apple-icon-60x60.png"></link>
                <link rel="apple-touch-icon" sizes="72x72" href="/apple-icon-72x72.png"></link>
                <link rel="apple-touch-icon" sizes="76x76" href="/apple-icon-76x76.png"></link>
                <link rel="apple-touch-icon" sizes="114x114" href="/apple-icon-114x114.png"></link>
                <link rel="apple-touch-icon" sizes="120x120" href="/apple-icon-120x120.png"></link>
                <link rel="apple-touch-icon" sizes="144x144" href="/apple-icon-144x144.png"></link>
                <link rel="apple-touch-icon" sizes="152x152" href="/apple-icon-152x152.png"></link>
                <link rel="apple-touch-icon" sizes="180x180" href="/apple-icon-180x180.png"></link>
                <link rel="icon" type="image/png" sizes="192x192" href="/android-icon-192x192.png"></link>
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png"></link>
                <link rel="icon" type="image/png" sizes="96x96" href="/favicon-96x96.png"></link>
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png"></link>
                <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-1BmE4kWBq78iYhFldvKuhfTAU6auU8tT94WrHftjDbrCEXSU1oBoqyl2QvZ6jIW3" crossOrigin="anonymous"></link>
                <title>{props.titulo}</title>
            </head>
        </Fragment>
    )
}

export default Head